import React, { useState } from "react";
import PropTypes from "prop-types";

import { useCouponDiscount } from "./hooks";
import { CouponForm, DiscountField } from "./components";

function Coupon({ currency }) {
  const [coupon, setCoupon] = useState();
  const [isCouponFormOpen, setIsCouponFormOpen] = useState();

  const { calculateCouponDiscount, removeCoupon, loading, error } =
    useCouponDiscount(setCoupon);

  if (coupon) {
    return (
      <DiscountField
        coupon={coupon}
        onRemove={() => {
          setIsCouponFormOpen(false);
          removeCoupon();
        }}
        currency={currency}
      />
    );
  }

  if (isCouponFormOpen) {
    return (
      <CouponForm
        loading={loading}
        error={error}
        onApply={calculateCouponDiscount}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => {
        return setIsCouponFormOpen(true);
      }}
      style={{
        color: "#4183C4",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        padding: "0",
        fontFamily: "Helvetica Neue",
        fontWeight: "bold",
        marginTop: "20px",
      }}
    >
      Apply Coupon
    </button>
  );
}

Coupon.propTypes = { currency: PropTypes.string.isRequired };

Coupon.defaultProps = {};

export default Coupon;
